import { api } from '@/utils/api'
import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 吹き出し用メッセージ情報取得
 */
export namespace ApiTaMg010 {
  // API Name
  export const name: string = 'ApiTaMg010'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/chrMessages'

    export interface Request {
      query: {
        courseId: string
        planId: string
      }
    }

    export interface Response {
      id: string
      message: string
    }
  }

  // API本体
  export class Api
    extends ApiBase
    implements Gettable<Get.Request, Get.Response, ResponseError>
  {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        id: '',
        message: '',
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
